import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "main-container flex justify-center" }
const _hoisted_3 = {
  key: 0,
  class: "detail-zone"
}
const _hoisted_4 = { class: "search-zone flex justify-start space-x-3" }
const _hoisted_5 = { class: "search-zone-input" }
const _hoisted_6 = { class: "content-zone" }
const _hoisted_7 = { class: "content-zone-body" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "content-item-title" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "pagination-zone" }
const _hoisted_12 = {
  key: 1,
  class: "detail-zone detail-info-zone"
}
const _hoisted_13 = { class: "detail-info-zone-title" }
const _hoisted_14 = { class: "detail-info-zone-date m-y-[2px]" }
const _hoisted_15 = { class: "text-[#999999]" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 0,
  class: "file-zone m-t-[20px] flex"
}

import { onMounted, ref, unref } from 'vue';
import { Pagination } from 'ant-design-vue';
import { api } from '@/api/Api';
import { useRouter } from 'vue-router';
import DOMPurify from 'dompurify';
import CommonHeader from './CommonHeader.vue';
import CommonFooter from './CommonFooter.vue';
import { UploadOutlined } from '@ant-design/icons-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

//获取当前日期 2024年5月10日 星期五
const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() + 1;
const day = date.getDate();
const week = date.getDay();
const weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
const weekStr = weekArr[week];
const timeStr = `${year}年${month}月${day}日 ${weekStr}`;
// console.log(dateStr);

const router = useRouter();

const searchKey = ref<string>();

const noticeData = ref([]);

const pageSize = ref<any>(10);
const current = ref<any>(1);
const total = ref<any>(100);

//分页事件
const onChange = (page, pageSizeCount) => {
  current.value = page;
  pageSize.value = pageSizeCount;
  handleSearch();
};

//搜索事件
const handleSearch = async (isRestPage = false) => {
  isRestPage && (current.value = 1);
  let params = {
    pageNo: unref(current),
    pageSize: unref(pageSize),
    title: unref(searchKey),
    auditStatus: 1,
  };
  const result = await api.externalList(params);
  const res = result.result
  total.value = res.total;
  noticeData.value = res.records.map((item) => {
    return {
      ...item,
      fileUrlsArray: item.fileUrls ? (item.fileUrls.split(',').map(fileItemUrl => {
        return {
          name: fileItemUrl.split('/').pop(),
          url: fileItemUrl,
        }
      })) : [],
    }
  });
  console.log('noticeData', noticeData.value)
};

const handleReset = () => {
  searchKey.value = '';
  handleSearch(true);
}; //重置事件
//查看详情
const isShowDetail = ref<boolean>(false);
const detail = ref<any>({});
const handleDetail = (item: any) => {
  window.open(location.origin + '/#/detail?id=' + item.id)
  // console.log('detail', item);
  // isShowDetail.value = true;
  // detail.value = { ...item };
};

//dom 清理
const sanitizedContent = (content: string) => {
  return DOMPurify.sanitize(content);
  // return content;
};
onMounted(() => {
  handleSearch(true);
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_upload = _resolveComponent("a-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createVNode(CommonHeader, { title: "南京市电动自行车集中充（换）电设施建设运营监管服务平台公告" })
    ]),
    _createElementVNode("main", _hoisted_2, [
      (!isShowDetail.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_input, {
                  placeholder: "请输入关键字搜索",
                  value: searchKey.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchKey).value = $event))
                }, null, 8, ["value"])
              ]),
              _createVNode(_component_a_button, {
                type: "primary",
                style: {"margin-left":"10px"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSearch(true)))
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("查询")
                ])),
                _: 1
              }),
              _createVNode(_component_a_button, {
                type: "default",
                style: {"margin-left":"10px"},
                onClick: handleReset
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("重置")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "content-zone-header" }, [
                _createElementVNode("div", {
                  class: "text-center",
                  style: {"width":"80%"}
                }, "公告名称"),
                _createElementVNode("div", {
                  class: "text-center",
                  style: {"width":"20%"}
                }, "发布日期")
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeData.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "content-item",
                    key: index,
                    onClick: ($event: any) => (handleDetail(item))
                  }, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(item.createTime), 1)
                  ], 8, _hoisted_8))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_unref(Pagination), {
                  size: "small",
                  current: current.value,
                  "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((current).value = $event)),
                  "page-size": pageSize.value,
                  "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageSize).value = $event)),
                  showSizeChanger: "",
                  total: total.value,
                  "show-total": (total, range) => `第${range[0]}-${range[1]}条 / 共 ${total} 条`,
                  onChange: onChange
                }, null, 8, ["current", "page-size", "total", "show-total"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (isShowDetail.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _createVNode(_component_a_breadcrumb, { separator: ">" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_breadcrumb_item, {
                    style: {"cursor":"pointer"},
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (isShowDetail.value = false))
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("返回公告列表")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_a_breadcrumb_item, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(detail.value.title), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_13, _toDisplayString(detail.value.title), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, "发布日期：" + _toDisplayString(detail.value.createTime), 1)
            ]),
            _createVNode(_component_a_divider),
            _createElementVNode("div", {
              innerHTML: sanitizedContent(detail.value.content)
            }, null, 8, _hoisted_16),
            (detail.value.fileUrls && detail.value.fileUrls.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "file-zone-label m-t-[8px] text-[#FF0000]" }, "附件：", -1)),
                  _createVNode(_component_a_upload, {
                    "file-list": detail.value.fileUrlsArray,
                    "onUpdate:fileList": _cache[5] || (_cache[5] = ($event: any) => ((detail.value.fileUrlsArray) = $event)),
                    showUploadList: {
            showPreviewIcon: false,
            showDownloadIcon: true,
            showRemoveIcon: false,
          }
                  }, null, 8, ["file-list"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})